
















































































































import HourSelector from '../../core/components/HourSelector.vue';
import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import SimpleMap from '../../core/components/SimpleMap.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Button,
    Combobox,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import moment from 'moment';

@Component({
    components: {
        Loading,
        SimpleMap,
        Combobox,
        Button,
        DatePickerSingle,
        HourSelector
    }
})
export default class ForcePeriodSowingPatch extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({ default() {return []}}) vehiclesOptions: Array<object>;
    @Prop() visible: boolean;
    @Prop() vehicleID: number;
    @Prop({ default: null }) patchData: object | null;
    modalTitle: string = 'Forzar período de trabajo';
    dateRangeSelected: any = [];
    discardSegment: boolean = false;
    calculateWithoutPerformance: boolean = false;
    ignoreAllFromTelemetry: boolean = false;
    discardPerformance: boolean = false;
    discardHumidity: boolean = false;
    isWork: boolean = false;
    ignoreAllFromCSV: boolean = false;
    discardPerformanceCSV: boolean = false;
    discardHumidityCSV: boolean = false;
    vehicleSelectedRV: boolean = false;
    forceOverlapped: boolean = false;
    errorMsg: string = '';
    startDate: any = null;
    vehicleSelected: any = null;
    startHour: string = '';
    endDate: any = null;
    endHour: string = '';

    get disableAllButtons() {
        return this.discardSegment;
    }

    get isPatch() {
        if (this.patchData !== null) {
            return true;
        } else {
            return false;
        }
    }

    updateStartDate(value) {
        this.startDate = value;
    }
    updateStartHour(value) {
        this.startHour = value;
    }
    updateEndDate(value) {
        this.endDate = value;
    }
    updateEndHour(value) {
        this.endHour = value;
    }
    updateVehicleSelected(value) {
        this.vehicleSelected = value;
    }
    updateVehicleSelectedRV(value) {
        this.vehicleSelectedRV = value;
    }

    ignorePerformanceFromTelemetry(value) {
        this.uncheckIgnoreAllFromTelemetry();
        this.calculateWithoutPerformance = value;
    }

    clickDiscardSegment(value) {
        this.ignoreAllFromTelemetry = this.discardSegment;
        this.ignoreAllFromCSV = this.discardSegment;
        this.discardAllFromTelemetry(this.discardSegment);
        this.discardAllFromCSV(this.discardSegment);
    }

    discardAllFromTelemetry(value) {
        this.discardPerformance = value;
        this.discardHumidity = value;
        this.calculateWithoutPerformance = value;
    }

    discardAllFromCSV(value) {
        this.discardPerformanceCSV = value;
        this.discardHumidityCSV = value;
    }

    clickIgnoreAllFromTelemetry() {
        this.discardAllFromTelemetry(this.ignoreAllFromTelemetry);
    }

    clickIgnoreAllFromCSV() {
        this.discardAllFromCSV(this.ignoreAllFromCSV);
    }

    uncheckIgnoreAllFromTelemetry() {
        this.ignoreAllFromTelemetry = false;
    }

    uncheckIgnoreAllFromCSV() {
        this.ignoreAllFromCSV = false;
    }

    setErrorForm(text) {
        this.errorMsg = text;
    }

    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
        this.closeModal();
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    submit() {
        if (!this.isPatch) {
            // this.postPeriod();
        } else {
            this.patchSegment();
        }
    }

    patchSegment() {
        let idToPatch = this.patchData !== null ? this.patchData['id'] : null;

        if (idToPatch) {
            let currentPeriod = {
                ...this.getData,
                segment_id: idToPatch
            }
            this.showLoadingDialog('Modificando...');
            InsuranceServices.patchIgnoreSegmentSowing(idToPatch, this.getData)
                .then(res => {
                    this.$emit('update-error-lapse', res['data']['forced_work_lapses']);
                    this.showSuccessLoadingDialog(res.data, res.data.message);
                })
                .catch(err => {
                    if(err && err.response && err.response.data && err.response.data.overlapped_periods){
                        
                        this.openModalOverlapWithSegment(err.response.data.overlapped_periods, currentPeriod);
                    }else{
                        this.showCatchLoadingDialog(err, 'Ocurrio un error');
                    }
                });
        }
    }

    loadPatchData() {
        if (this.isPatch && this.patchData !== null) {
            this.modalTitle = 'Modificar periodo';
            let startDate = moment(this.patchData['start_date'], 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD');
            let startHour = moment(this.patchData['start_date'], 'YYYY-MM-DDTHH:mm:ss').format('HH:mm');
            let endDate = moment(this.patchData['end_date'], 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD');
            let endHour = moment(this.patchData['end_date'], 'YYYY-MM-DDTHH:mm:ss').format('HH:mm');
            this.updateStartDate(startDate);
            this.isWork = this.patchData['is_work'];
            this.updateEndDate(endDate);
            this.updateStartHour(startHour);
            this.updateEndHour(endHour);

            if(this.vehiclesOptions.length > 0 && this.patchData['vehicle']){
                this.updateVehicleSelected(this.patchData['vehicle'])
            }
        } else {
            this.updateStartHour('00:00');
            this.updateEndHour('23:59');
        }
    }

    get getData() {
        return {
            vehicle: this.vehicleID !== -1 ? this.vehicleID : this.vehicleSelected['id'],
            start_date: this.getFullTimestamp(this.startDate, this.startHour),
            end_date: this.getFullTimestamp(this.endDate, this.endHour),
            is_work: this.isWork,
            force_overlapped: this.forceOverlapped
        };
    }

    get formIsValid() {
        this.setErrorForm('');
        if (this.startDate == null) {
            this.setErrorForm('No seleccionó Fecha de Inicio');
            return false;
        }

        if (this.endDate == null) {
            this.setErrorForm('No seleccionó Fecha de Fin');
            return false;
        }

        if(this.vehiclesOptions.length > 0 && this.vehicleSelected == null){
            this.setErrorForm('No seleccionó el Vehiculo');
            return false
        }
        return true;
    }

    getFullTimestamp(date, hour) {
        return date + 'T' + hour;
    }

    @Emit()
    closeModal() {}


    @Emit()
    openModalOverlapWithSegment(overlappedPeriods: Array<object>, currentPeriod:object) {
        
    }

    mounted() {
        this.$nextTick(() => {
            this.loadPatchData();
        });
    }
}
